<template><svg xmlns="http://www.w3.org/2000/svg" width="30" height="15" viewBox="0 0 30 15">
  <path d="M1.5,0h27A1.5,1.5,0,0,1,30,1.5h0A1.5,1.5,0,0,1,28.5,3H1.5A1.5,1.5,0,0,1,0,1.5H0A1.5,1.5,0,0,1,1.5,0Z"/>
  <path d="M1.5,6h27A1.5,1.5,0,0,1,30,7.5h0A1.5,1.5,0,0,1,28.5,9H1.5A1.5,1.5,0,0,1,0,7.5H0A1.5,1.5,0,0,1,1.5,6Z"/>
  <path d="M11.5,12h17A1.5,1.5,0,0,1,30,13.5h0A1.5,1.5,0,0,1,28.5,15h-17A1.5,1.5,0,0,1,10,13.5h0A1.5,1.5,0,0,1,11.5,12Z"/>
</svg></template>